module.exports = __webpack_public_path__ + "img/hotel-mundial.0ab99e8c.jpg";